import { render, staticRenderFns } from "./HeaderBack.vue?vue&type=template&id=e226f88a&"
import script from "./HeaderBack.vue?vue&type=script&lang=js&"
export * from "./HeaderBack.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBack.vue?vue&type=style&index=0&id=e226f88a&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e226f88a')) {
      api.createRecord('e226f88a', component.options)
    } else {
      api.reload('e226f88a', component.options)
    }
    module.hot.accept("./HeaderBack.vue?vue&type=template&id=e226f88a&", function () {
      api.rerender('e226f88a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LMSGiframe/components/HeaderBack.vue"
export default component.exports